module.exports = __webpack_public_path__ + "img/logo.22a29432.png";